import { render, staticRenderFns } from "./doanh-so-tu-van.vue?vue&type=template&id=eb8316ca"
import script from "./doanh-so-tu-van.vue?vue&type=script&lang=js"
export * from "./doanh-so-tu-van.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports